module.exports = __webpack_public_path__ + "img/healthy-food.fd3a6039.jpg";